import React, { Component, Fragment } from "react";
import CenterElement from "../activitiesUi/activity/activityComponent/CenterElement";
import Doughnut from "react-doughnut";
import { Knob } from "primereact/knob";
import { Button } from "primereact/button";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  withRouter,
} from "react-router-dom";

import boy from "../imgs/ic_boywin.png";
import failedImg from "../imgs/failResultContainer.png";
import awards from "../imgs/ic_Awards.png";
import DifficultyLevel from "./result_page/DifficultyLevel";
import CognitiveResult from "./result_page/CognitiveResult";
import LOResult from "./result_page/LOResult";
import { DoughnutChartDemo } from "./result_page/DoughnutChartDemo";
import APIConnector from "./result_page/APIConnector";

class ResultPage extends Component {
  wrong_color = "#ff6280";
  right_color = "#57c2a1";
  skip_color = "#9f9f9f";

  state = {
    topic: { topicTitleAr: "" },
  };

  componentDidMount = () => {
    this.resultDiv.style.display = "inline-block";
    this.resultDiv.style.opacity = "1";

    let { app, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    let { callbackData } = quizViwerModel;

    let apiConnector = new APIConnector();
    apiConnector.getCourseTopicDataById(callbackData.topicId, (res) => {
      console.log(res.data);
      this.setState({ topic: res.data.courseTopicJson });
    });
  };

  render = () => {
    let { app, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    let { callbackData } = quizViwerModel;

    quizViwerModel.getTotalinDetails();

    let isSucceded = false;
    if (quizViwerModel.degree >= quizViwerModel.total / 2) isSucceded = true;

    return (
      <Fragment>
        <div>
          {window.showResultPage ? (
            <Fragment>
              <div
                ref={(el) => (this.resultDiv = el)}
                id="activityMainContainer"
                style={{
                  backgroundColor: "#fcfcfc",
                  direction: "rtl",
                  transition: "opacity 1.5s",
                  opacity: "0",
                  display: "none",
                  position: "relative",
                  width: "100%",
                  transition: "top 1s",
                  top: "0",
                  height: "100%",
                  overflow: "auto",
                }}
              >
                <div
                  className="grid align-items-stretch"
                  style={{ textAlign: "center" }}
                >
                  <div className=" col-4 ">
                    <div className="statistics_card" style={{ height: "100%" }}>
                      <div className="grid ">
                        <div className="col-9">
                          {" "}
                          {this.state.topic.topicTitleAr}{" "}
                        </div>
                        <b
                          className="col-3 statistics_value"
                          style={{
                            float: "left",
                            fontSize: "16px",
                            color: "#8057c3",
                          }}
                        >
                          {quizViwerModel.degree}/{quizViwerModel.total}
                        </b>

                        <div
                          style={{
                            marginTop: "10px",
                            marginRight: 0,
                            marginLeft: 0,
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          <Button
                            className="p-button-secondary p-button-text"
                            style={{
                              display: "none",
                              backgroundColor: "#f2effa",
                              borderRadius: "7px",
                              width: "100%",
                              color: "#8460c5",
                            }}
                            label="اعادة الاختبار"
                            onClick={() => {
                              quizViewer.retryQuiz();
                            }}
                          ></Button>

                          <DoughnutChartDemo
                            right={quizViwerModel.totalRight}
                            wrong={quizViwerModel.totalWrong}
                            skipped={quizViwerModel.totalSkipped}
                          />

                          {/* <div className="grid  justify-center buttonset" style={{ marginTop: "10px", textAlign: "center", marginRight: 0, marginLeft: 0, position: "relative", top: "225px" }}>
                                                        <h5> {this.getWithTimeFormat(quizViwerModel.timeTaken)}</h5>
                                                    </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-8">
                    <div className="statistics_card" style={{ height: "100%" }}>
                      <p
                        style={{
                          float: "right",
                          textAlign: "right",
                          width: "100%",
                        }}
                      >
                        الاجابات
                      </p>

                      <div
                        className="flex justify-content-center flex-wrap "
                        style={{ backgroundColor: "#f7f7f7", padding: "1rem" }}
                      >
                        <div className="flex-grow-1 flex align-items-center justify-content-center">
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              backgroundColor: "#7f58c3",
                              borderRadius: "50%",
                            }}
                          ></span>
                          <span
                            style={{
                              marginLeft: "0.25rem",
                              marginRight: "0.25rem",
                            }}
                          >
                            {" "}
                            عدد الاسئلة
                          </span>
                          <b> {quizViwerModel.total}</b>
                        </div>

                        <div className="flex-grow-1 flex align-items-center justify-content-center">
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              backgroundColor: this.right_color,
                              borderRadius: "50%",
                            }}
                          ></span>
                          <span
                            style={{
                              marginLeft: "0.25rem",
                              marginRight: "0.25rem",
                            }}
                          >
                            إجابات صحيحة
                          </span>

                          <b> {quizViwerModel.totalRight} </b>
                        </div>

                        <div className="flex-grow-1 flex align-items-center justify-content-center">
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              backgroundColor: this.wrong_color,
                              borderRadius: "50%",
                            }}
                          ></span>
                          <span
                            style={{
                              marginLeft: "0.25rem",
                              marginRight: "0.25rem",
                            }}
                          >
                            {" "}
                            إجابات خاطئة
                          </span>

                          <b> {quizViwerModel.totalWrong} </b>
                        </div>

                        <div className="flex align-items-center justify-content-center">
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              backgroundColor: this.skip_color,
                              borderRadius: "50%",
                            }}
                          ></span>
                          <span
                            style={{
                              marginLeft: "0.25rem",
                              marginRight: "0.25rem",
                            }}
                          >
                            {" "}
                            تخطي السؤال
                          </span>

                          <b> {quizViwerModel.totalSkipped} </b>
                        </div>
                      </div>
                      <div
                        className="grid text-center"
                        style={{ marginRight: 0, marginLeft: 0 }}
                      >
                        {/* <div className="p-col-1"></div> */}
                        <div
                          className="flex flex-wrap  justify-content-center "
                          style={{
                            paddingTop: "1rem",
                            direction:
                              quizViwerModel.currentLang ==
                              quizViwerModel.ARABIC_LANG
                                ? "rtl"
                                : "ltr",
                            lineHeight: "normal",
                          }}
                        >
                          {quizViwerModel.activityArr.map((activity, index) => {
                            let color = activity.isSkipped
                              ? this.skip_color
                              : activity.answeredTrue
                              ? this.right_color
                              : this.wrong_color;

                            return (
                              <div
                                key={index}
                                className="flex  justify-content-center"
                                onClick={(e) => this.handleReviewModel(index)}
                                style={{
                                  color: "white",
                                  cursor: "pointer",
                                  margin: "5px",
                                  backgroundColor: color,
                                  padding: "1rem",
                                  width: "3rem",
                                  borderRadius: "10px",
                                }}
                              >
                                {quizViwerModel.currentLang ==
                                quizViwerModel.ARABIC_LANG
                                  ? quizViewer.toArabicDigits(index + 1 + "")
                                  : (index + 1).toFixed(0)}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid">
                  <div className=" col-4 ">
                    <div className="statistics_card" style={{ height: "100%" }}>
                      <h5> مستويات الصعوبة</h5>
                      <DifficultyLevel
                        app={this.props.app}
                        quizViewer={this.props.quizViewer}
                      />
                    </div>
                  </div>
                  <div className=" col-4 ">
                    <div className="statistics_card" style={{ height: "100%" }}>
                      <h5> المستوي المعرفي </h5>
                      <CognitiveResult
                        app={this.props.app}
                        quizViewer={this.props.quizViewer}
                      />
                    </div>
                  </div>
                  <div className=" col-4 ">
                    <div className="statistics_card" style={{ height: "100%" }}>
                      <h5> نواتج التعلم</h5>
                      <LOResult
                        app={this.props.app}
                        quizViewer={this.props.quizViewer}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          ) : (
            ""
          )}
        </div>
      </Fragment>
    );
  };

  getWithTimeFormat = (totalSeconds) => {
    let seconds = totalSeconds % 60;
    let minutes = (totalSeconds - seconds) / 60;

    let format = "(" + minutes + " دقيقية : " + seconds + " ثانية)";

    return format;
  };

  handleGoBack = () => {
    window.history.go(-2);
  };
  handleReset = () => {
    let { app, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    quizViwerModel.resetApp();
    quizViewer.setState({ quizViwerModel });
  };

  handleReviewModel = (index) => {
    let { app, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;
    quizViwerModel.reviewActivity(index);
    quizViewer.setState({ quizViwerModel });

    this.props.history.push("/activity_ui");
  };
}

export default withRouter(ResultPage);
